import { Megaphone, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { site } from "../config/siteConfig";

export const AnnouncementBar = () => (
  <div
    data-testid="announcement-bar"
    className="bg-brand text-white"
    role="region"
    aria-label="School announcements"
  >
    <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2 text-sm sm:justify-between">
      <p className="flex items-center gap-2 font-medium">
        <Megaphone className="h-4 w-4 text-brand-amber" aria-hidden="true" />
        {site.announcement}
      </p>
      <Link
        to="/admissions"
        data-testid="announcement-enquire-link"
        className="inline-flex items-center gap-1 font-semibold text-brand-amber underline-offset-4 transition-colors hover:text-amber-300 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
      >
        Enquire Now
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </Link>
    </div>
  </div>
);
